import { i18n } from '../../i18n/translate';
import { ConfirmationModal } from '../ConfirmationModal';
import React from 'react';
import { Props } from './types';

export const CancelConfirmModal = (props: Props) => {
  const {
    body = i18n.t('Are you sure you want to discard all your changes?'),
    branded = false,
    cancelButtonText = i18n.t('No'),
    confirmButtonText = i18n.t('Yes'),
    onCancelClose = () => {},
    size = 'md',
    title = i18n.t('Discard unsaved changes'),
    show = false,
    renderAsLegacy,
  } = props;

  return (
    <ConfirmationModal
      branded={branded}
      cancelButtonText={cancelButtonText}
      confirmButtonText={confirmButtonText}
      onCancel={() => onCancelClose(false)}
      onConfirm={() => onCancelClose(true)}
      show={show}
      size={size}
      title={title}
      renderAsLegacy={renderAsLegacy}
    >
      <div>{body}</div>
    </ConfirmationModal>
  );
};
